import { Actions, AuthActionTypes } from '../_actions/auth.actions';
import {
  UserData,
  TokenAPI,
  ValidateTokenResponse,
  AppLoginInfoResponse
} from '../_models/auth.models';
import { Error } from '../_models/auth.models';
import { Operations, OpTypes } from '../_models/general.model';

/**
 * State interface
 */
export interface AuthState {
  token: TokenAPI | null;
  validateToken: ValidateTokenResponse | null;
  appInfoResponse: AppLoginInfoResponse | null;
  userData: UserData | null;
  loginResponse: any;
  loginError: any;
  error: Error | null;
  operations: Operations;
}

/**
 * Initials State
 */
export const initialState: AuthState = {
  token: null,
  validateToken: null,
  loginResponse: null,
  loginError: null,
  appInfoResponse: null,
  userData: null,
  error: null,
  operations: {},
};

/**
 * Reducer
 */
export const AuthReducer = (
  state = initialState,
  action: Actions
): AuthState => {
  switch (action.type) {
    case AuthActionTypes.TOKEN:
      return {
        ...state,
        token: null,
        error: null,
        validateToken: null,
      };
    case AuthActionTypes.VALIDATE_TOKEN:
      return {
        ...state,
        token: null,
        error: null,
        validateToken: null,
      };
    case AuthActionTypes.APP_LOGIN_INFO:
      return {
        ...state,
        token: null,
        error: null,
        appInfoResponse: null,
      };
    case AuthActionTypes.LOGIN_USER:
      return {
        ...state,
        token: null,
        error: null,
        loginError: null,
        validateToken: null,
      };
    case AuthActionTypes.REGISTER_USER:
      return {
        ...state,
        token: null,
        error: null,
        validateToken: null,
      };
    case AuthActionTypes.TOKEN_SUCCESS:
      return {
        ...state,
        token: action.payload,
        error: null,
      };
    case AuthActionTypes.VALIDATE_TOKEN_SUCCESS:
      return {
        ...state,
        validateToken: action.payload,
        error: null,
      };
    case AuthActionTypes.APP_LOGIN_INFO_SUCCESS:
      return {
        ...state,
        appInfoResponse: action.payload,
        error: null,
      };
    case AuthActionTypes.LOGIN_USER_SUCCESS:
      return {
        ...state,
        loginResponse: action.payload,
        error: null,
      };
    case AuthActionTypes.REGISTER_USER_SUCCESS:
      return {
        ...state,
        validateToken: action.payload,
        operations: {
          ...state.operations,
          [action.refId]: {
            type: OpTypes.CREATE,
            error: null,
          },
        },
        error: null,
      };
    case AuthActionTypes.TOKEN_FAILED:
    case AuthActionTypes.VALIDATE_TOKEN_FAILED:
    case AuthActionTypes.APP_LOGIN_INFO_FAILED:
      return {
        ...state,
        error: action.payload,
      };
    case AuthActionTypes.LOGIN_USER_FAILED:
      return {
        ...state,
        loginResponse: action.payload,
        loginError: action.payload,
      };
    case AuthActionTypes.REGISTER_USER_FAILED:
      return {
        ...state,
        operations: {
          ...state.operations,
          [action.refId]: {
            type: OpTypes.FAILED,
            error: action.payload,
          },
        },
        error: action.payload,
      };
    case AuthActionTypes.RESET:
      return {
        error: null,
        token: null,
        userData: null,
        loginResponse: null,
        loginError: null,
        validateToken: null,
        appInfoResponse: null,
        operations: {},
      };
    default:
      return state;
  }
};
